import classNames from "classnames";
import React, { PureComponent } from "react";

import { ITestable, testAttr } from "@/browser";

interface Props extends ITestable {
  onClick: () => void;
}

export class Clear extends PureComponent<Props> {
  handleClearClick = () => {
    const { onClick } = this.props;

    if (onClick) {
      onClick();
    }
  };

  render() {
    const clearClass = classNames("el-form-clear");

    return (
      <span className={clearClass} onClick={this.handleClearClick} {...testAttr(this.props, { sufix: "clear" })} />
    );
  }
}
